import { Alert, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { WfsBadRequestResponse } from "../../../types/Wfs/WfsResponse";
import { useTenantContext } from "../../../context/Tenant/TenantContext";

export interface BadRequestViewProps {
  badRequest: WfsBadRequestResponse;
  reset: () => void;
}

const BadRequestView = ({
  badRequest: { error },
  reset,
}: BadRequestViewProps) => {
  const navigate = useNavigate();
  const { config } = useTenantContext();
  const supportEmail: string = config.supportEmail ?? "support@basemap.co.uk";
  const supportLabel: string = config.supportLabel ?? "Basemap";
  return (
    <>
      <Modal.Body>
        <Alert variant="danger">
          <Alert.Heading>Cannot process your order</Alert.Heading>
          {error}
        </Alert>
        Please contact{" "}
        <a href={`mailto:${supportEmail}`}>{supportLabel}</a>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => reset()}>
          Retry
        </Button>
        <Button variant="danger" onClick={() => navigate("/")}>
          Cancel
        </Button>
      </Modal.Footer>
    </>
  );
};

export default BadRequestView;
